import { useQuery } from '@tanstack/react-query';
import { resolvePolicy } from '@/lib/policies/api';
import type { TransportMode } from '@/lib/policies/types';

/**
 * The ground-transport mode the governing policy states for a station —
 * `AUTOMATIC` (transport dispatches on hotel confirmation) or `ON_DEMAND` (the
 * passenger asks, or the operator dispatches). Resolved the way
 * `apps/transport` resolves it: tenant airline (BFF-pinned) + the disrupted
 * flight's origin. The roster row carries no cabin class, so a per-tier
 * override is not read here — the default rule answers.
 *
 * `undefined` while loading, on a failed read, or when the policy does not
 * state a mode: the screen then claims nothing about what happens on its own.
 */
export function useTransportMode(airport: string | undefined, enabled = true): TransportMode | undefined {
  const query = useQuery({
    queryKey: ['policies', 'resolve', 'transportMode', airport ?? ''],
    queryFn: () => resolvePolicy(airport ? { airport } : {}),
    enabled: enabled && !!airport,
    staleTime: 5 * 60_000,
    refetchOnWindowFocus: false,
    retry: false,
  });
  return query.data?.resolved ? query.data.transportMode : undefined;
}
